// @flow

import type {Effect} from '../../types'

import {
  take,
  call,
  select,
  put,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'
import {showMap} from '../../map/lib/showMap'
import {ensureMapReady} from './ensureMapReady'
import {fetchServiceProvider} from '../../place/lib/fetchServiceProvider'
import {locationToPointLocation} from '../lib/locationToPointLocation'
import {loadServiceProvidersFromLocation} from './loadServiceProvidersFromLocation'
import {mapActions} from '../actions'
import {googleMapApi} from '../../../google-map'
import {mapSelectors} from '../selectors'
import {moveCenterMap} from '../lib/moveCenterMap'

export function* enterMapPlaceEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'map') {
      yield call(ensureMapReady)
      yield call(showMap)
      try {
        if (route.params.place) {
          const map:GoogleMap = yield select(mapSelectors.getGoogleMap)
          const place: ServiceProvider = yield call(fetchServiceProvider, route.params.place)
          yield call(moveCenterMap, place.location.latitude, place.location.longitude, map)
          const pointLocation: string = yield call(locationToPointLocation, place.location) 
          const placeList: ServiceProvider[] = yield call(loadServiceProvidersFromLocation, pointLocation)
          yield put(mapActions.setServiceProviders(placeList))
          yield call(googleMapApi.makeMapMarkers, map, placeList, '/images/marker.png') 
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}